import { PriceDetails } from "steps/types/step";

export const priceDetailsToArray = (priceDetails: PriceDetails) => {
  return Object.entries(priceDetails ?? {})
    .map(([key, value]) => ({
      name: key,
      amount: value.amount,
    }))
    .filter((price) => price.amount >= 0);
};
